import ErrorLayoutPage from "layout/ErrorLayoutPage";
import { useTranslation } from "react-i18next";
import { NotFoundPageSource } from "routes/routes.typing";

interface Props {
  source?: NotFoundPageSource;
}

const HEADLINE_BY_SOURCE: Record<NotFoundPageSource, string> = {
  [NotFoundPageSource.Offer]: "page.notfound.offer-headline",
  [NotFoundPageSource.Task]: "page.notfound.task-headline",
};

function NotFoundPage({ source }: Props) {
  const { t } = useTranslation("error");
  const headlineKey = source !== undefined ? HEADLINE_BY_SOURCE[source] : "page.notfound.headline";

  return (
    <ErrorLayoutPage
      errorCode={404}
      title={t(headlineKey)}
      description={t("page.notfound.secondary")}
    />
  );
}

export default NotFoundPage;
